import axios, { AxiosRequestConfig } from "axios";

import GetUrl from "../../hooks/GetUrl";

const configureApi = (baseURL?: string) => axios.create({ baseURL });

const api = configureApi(process.env.REACT_APP_API);

api.interceptors.request.use(
  async (config: AxiosRequestConfig): Promise<any> => {
    const path = GetUrl();
    api.defaults.headers.common["Access-Control-Allow-Origin"] = path;

    return config;
  }
);

export { api };
